export const PERMISSIONS = {
  AC_RECEIVABLE_VIEW: 'AC_RECEIVABLE_VIEW',
  AC_RECEIVABLE_EXPORT: 'AC_RECEIVABLE_EXPORT',
};
